export default __webpack_public_path__ + "static/victoriaville-6db2d27f167f1cf8d9a8806d57792a27.png";